import { connect, MapStateToProps } from "react-redux";

import { createGetAttributeNames } from "@multiweb/reactCore/datasource";
import { IAppState } from "@multiweb/types/react";
import { ListHeaderComponent, ListHeaderComponentProps } from "../ListHeaderComponent";

export type ListHeaderProps = {
    /** Unikátní klíč pro DataSource. */
    dataSourceKey: string;
};

type StateProps = Pick<ListHeaderComponentProps, "iconDataSourceAttributeNames" | "contentDataSourceAttributeNames">;

const createMapStateToProps: () => MapStateToProps<StateProps, ListHeaderProps, IAppState> = () => {
    const getIconDataSourceAttributes = createGetAttributeNames(true);
    const getContentDataSourceAttributes = createGetAttributeNames(false);

    return (state, { dataSourceKey }) => ({
        iconDataSourceAttributeNames: getIconDataSourceAttributes(state, dataSourceKey),
        contentDataSourceAttributeNames: getContentDataSourceAttributes(state, dataSourceKey),
    });
};

export const ListHeader = connect(createMapStateToProps)(ListHeaderComponent);
